import { FieldAdapter } from "./FieldAdapter";

export class DateTimeFieldAdapter extends FieldAdapter<Date> {
	constructor(hasValue: () => boolean, onTriggered: (value: Date) => void) {
		super({
			hasValue,
			resolveValue: capture => capture.now,
			onTriggered: value => onTriggered(new Date(value))
		});
	}
}
